import { BlockStack, Box, Button, Card, Icon, InlineStack, Text } from '@shopify/polaris';
import React from 'react';
import {
    QuestionCircleIcon,
    TeamIcon,
    ChatIcon
  } from '@shopify/polaris-icons';
import utils from '../../../../../utils/utils';
import './index.css'
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
const Index = ()=> {
    const router = useHistory()
    return (
        <Box>
            <Card>
                <BlockStack gap={400}>
                    <Text variant="headingSm" as="h6">
                    Resources
                    </Text>
                    <Box>
                    <BlockStack gap={400}>
                        <Card roundedAbove="xs">
                           <Box>
                            <InlineStack gap={200} blockAlign='center' wrap={false}>
                                <Box><Icon source={QuestionCircleIcon}/></Box>
                                <Box style={{flex:1}}>Dropshipman Help center</Box>
                                <Box><Button url='https://help.dropshipman.com/' external>Get help</Button></Box>
                            </InlineStack>
                           </Box>
                           <Box style={{width:'100%',height:'1px',margin:'8px 0',background:"rgba(227, 227, 227, 1)"}}></Box>
                           <Box style={{width:'100%',height:'1px',margin:'8px 0',background:"rgba(227, 227, 227, 1)"}}></Box>
                           <Box>
                            <InlineStack gap={200} blockAlign='center' wrap={false}>
                                <Box><Icon source={TeamIcon}/></Box>
                                <Box style={{flex:1}}>Dropshipman Partner</Box>
                                <Box><Button onClick={()=>{
                                    utils.routeJump1(router,`/admin/recommended-apps?selected_tab=1`)
                                }}>View partners</Button></Box>
                            </InlineStack>
                           </Box>
                           <Box style={{width:'100%',height:'1px',margin:'8px 0',background:"rgba(227, 227, 227, 1)"}}></Box>
                           <Box>
                            <InlineStack gap={200} blockAlign='center' wrap={false}>
                                <Box><Icon source={ChatIcon}/></Box>
                                <Box style={{flex:1}}>Dropshipman Discord Community</Box>
                                <Box><Button  url='https://discord.com/invite/FXPB6vCEbt' external>Follow us on Discord</Button></Box>
                            </InlineStack>
                           </Box>
                        </Card>
                       
                        </BlockStack>
                    </Box>
                </BlockStack>
            </Card>
        </Box>
    );
}

export default Index;
